import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/history',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'history' */ './component')],
			render: ([History]) => <History />,
			onEnter: async ({ next }) => {
				console.log('on Enter history');
				await next();
				console.log('on Enter history / end');
			},
		},
	],
};

export default routes;
